import { Link } from "react-router-dom";
import { Trash2, ShoppingCart } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/web/components/ui/sheet";
import { Button } from "@/web/components/ui/button";
import { useCart } from "@/lib/cart";
import { formatNzd } from "@/lib/utils";

export default function CartSheet() {
  const { items, open, setOpen, remove, setQty, subtotalCents, count } = useCart();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="flex w-full flex-col sm:max-w-md">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2"><ShoppingCart className="h-5 w-5" /> Your cart</SheetTitle>
        </SheetHeader>

        {count === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center">
            <div className="rounded-full bg-surface p-5"><ShoppingCart className="h-8 w-8 text-body/50" /></div>
            <p className="text-sm text-body">Your cart is empty.</p>
            <Button asChild variant="outline"><Link to="/products" onClick={() => setOpen(false)}>Browse products</Link></Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto py-4">
              <ul className="space-y-4">
                {items.map((item) => (
                  <li key={item.productId} className="flex gap-3">
                    <div className="h-16 w-16 flex-none rounded-md bg-surface" />
                    <div className="flex flex-1 flex-col">
                      <div className="flex items-start justify-between gap-2">
                        <span className="text-sm font-medium text-ink">{item.name}</span>
                        <button onClick={() => remove(item.productId)} aria-label="Remove" className="text-body/60 hover:text-destructive">
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                      <span className="text-sm text-body">{formatNzd(item.priceCents)}</span>
                      <div className="mt-2 inline-flex items-center gap-2">
                        <button onClick={() => setQty(item.productId, item.qty - 1)} className="h-7 w-7 rounded border border-border text-sm">−</button>
                        <span className="w-6 text-center text-sm">{item.qty}</span>
                        <button onClick={() => setQty(item.productId, item.qty + 1)} className="h-7 w-7 rounded border border-border text-sm">+</button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-t border-border pt-4">
              <div className="mb-3 flex items-center justify-between text-sm">
                <span className="text-body">Subtotal</span>
                <span className="font-semibold text-ink">{formatNzd(subtotalCents)}</span>
              </div>
              <Button asChild className="w-full"><Link to="/checkout" onClick={() => setOpen(false)}>Checkout</Link></Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
